var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchicon = function SvgSearchicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M9.79 15.832A6.04 6.04 0 0 1 3.75 9.79 6.04 6.04 0 0 1 9.79 3.75a6.04 6.04 0 0 1 6.04 6.04 6.04 6.04 0 0 1-6.04 6.042m0-10.89a4.817 4.817 0 0 0-4.848 4.849 4.817 4.817 0 0 0 4.848 4.848 4.817 4.817 0 0 0 4.849-4.848c0-2.703-2.226-4.849-4.849-4.849"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M16.706 17.5a.72.72 0 0 1-.557-.238L13.288 14.4a.77.77 0 0 1 0-1.113.77.77 0 0 1 1.113 0l2.861 2.862a.77.77 0 0 1 0 1.113.72.72 0 0 1-.556.238"
  })));
};
export default SvgSearchicon;